// extracted by mini-css-extract-plugin
export var avatar = "_sc-3";
export var avatarContainer = "_sc-2";
export var avatarSpacer = "_sc-5";
export var avatarSpacerContainer = "_sc-4";
export var avatarStackContainer = "_sc-1";
export var bubble = "_sc-0";
export var remainderBubble = "_sc-6";